module.exports = {
  background: '#222222',
  white: '#ffffff',
  accent: '#f8aa94',
  bright: '#cccccc',
  dark: '#333333',
  gray: '#555555',
  lightGray: '#bbbbbb',
  superLightGray: '#dedede'
};



// WEBPACK FOOTER //
// ./src/styles/new-colors.js